import { useMemo, useCallback } from 'react';
import { useAppThunkDispatch } from 'state/store';
import { useSelector } from 'react-redux';
import {
  selectSelectedStageIds,
  selectSelectedStages,
  selectStages,
  setSelectedStageIds,
} from 'state/ProjectsList/filters/Processes/stagesSlice';
import { getProcessesList } from 'state/ProjectsList/filters/Processes/processesSlice';
import { ProcessStage } from 'utils/types/projectsList';

interface UseProjectStagesParams {
  appliedFilters?: string[];
}

interface UseProjectStagesReturn {
  fetchSelectedStages: (selectedStageIds: string[]) => Promise<void>;
  stages: ProcessStage[];
  selectedStageIds: string[];
  shouldFetchStages: boolean;
  selectedStages: ProcessStage[];
}

export const useProjectStages = ({
  appliedFilters,
}: UseProjectStagesParams): UseProjectStagesReturn => {
  const dispatch = useAppThunkDispatch();
  const stages = useSelector(selectStages);
  const selectedStageIds = useSelector(selectSelectedStageIds);
  const selectedStages = useSelector(selectSelectedStages);

  const fetchSelectedStages = useCallback(
    async (selectedStageIds: string[]) => {
      dispatch(setSelectedStageIds(selectedStageIds));
      await dispatch(getProcessesList());
    },
    [dispatch]
  );

  const shouldFetchStages = useMemo(() => {
    if (appliedFilters && appliedFilters.length > 0) {
      return (
        selectedStages.length === 0 ||
        appliedFilters.length !== selectedStageIds.length
      );
    }
    return stages.length === 0;
  }, [appliedFilters, selectedStageIds, selectedStages, stages]);

  return useMemo(() => {
    return {
      fetchSelectedStages,
      stages,
      selectedStageIds,
      shouldFetchStages,
      selectedStages,
    };
  }, [
    fetchSelectedStages,
    stages,
    selectedStageIds,
    shouldFetchStages,
    selectedStages,
  ]);
};
